var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FilespaceFormatForMigrations } from '@lucidlink/dto/validation';
import { ArrowCircleBrokenUpRightIcon, Box, ButtonLink, Label, SpinnerIcon, Table, translate, Typography, } from '@lucidlink/uicore';
import { NOTIFICATION_EVENT_ACTIONS, UpgradeFilespaceFeatureFlagProperties, useIsEnabledFeatureFlag, } from '@lucidlink/workspacemanagement';
import { buildNotificationEventUrl } from '#services';
import styles from './FilespaceDetailsWebModalTable.module.css';
export const FilespaceDetailsWebModalTable = ({ canUpgrade, filespace, }) => {
    _react_refresh_temp_2();
    const { isEnabledFeatureFlag } = useIsEnabledFeatureFlag();
    const cloudProviderName = filespace.storageProviderId ?? '';
    const cloudProviderRegionId = filespace.storageRegionId ?? '';
    const upgradeButtonText = translate('Upgrade to {{latestFilespaceFormat}}', { latestFilespaceFormat: FilespaceFormatForMigrations });
    const upgradeInDesktopUrl = buildNotificationEventUrl(NOTIFICATION_EVENT_ACTIONS.OpenFilespaceUpgrade, {
        workspaceId: filespace.workspaceId,
        filespaceId: filespace.id,
    });
    return (_jsx(Table, { className: styles.Table, columnConfigList: [
            {
                columnGrow: 'flex-2',
                id: 'column-row-label',
                label: translate('details').toString(),
                renderData: (data) => {
                    return (_jsxs(Box, { align: "center", gap: "m", children: [_jsx(Typography, { className: styles.DataLabel, "data-testid": "column-row-label", kind: "p", children: data.label }), data.canUpgrade && (_jsx(ButtonLink, { "data-testid": "upgrade-filespace", kind: "secondary", size: "small", StartIcon: ArrowCircleBrokenUpRightIcon, to: upgradeInDesktopUrl, children: upgradeButtonText })), data.isMigrating && (_jsx(Label, { color: "static_info", "data-testid": "upgrading", StartIcon: SpinnerIcon, text: translate('Upgrading') }))] }));
                },
            },
            {
                columnUtility: 'justify-end',
                id: 'column-row-value',
                ariaLabel: translate('value'),
                renderData: (data) => {
                    return (_jsx(Typography, { className: styles.DataValue, "data-testid": "column-row-value", kind: "p", children: data.value }));
                },
            },
        ], data: [
            {
                label: translate('Cloud provider'),
                value: `${cloudProviderName}${cloudProviderRegionId
                    ? ' (' + cloudProviderRegionId + ')'
                    : ''}`,
            },
            {
                label: translate('Filespace format'),
                value: filespace.format,
                ...(isEnabledFeatureFlag(UpgradeFilespaceFeatureFlagProperties)
                    ? {
                        canUpgrade,
                        isMigrating: filespace.isMigrating,
                    }
                    : {}),
            },
        ], "data-testid": "filespace-web-details-table", dataIdAccessor: (dataItem) => dataItem.label, loadingLabel: translate('Loading filespace details') }));
};
_react_refresh_temp_1 = FilespaceDetailsWebModalTable;
$RefreshReg$(_react_refresh_temp_1, "FilespaceDetailsWebModalTable");
_react_refresh_temp_2(FilespaceDetailsWebModalTable, "6HsrWjF+5EAv2CSMnV7eNsAOvwM=", false, () => [useIsEnabledFeatureFlag]);
